// extracted by mini-css-extract-plugin
export default {"Agreement":"Agreement_Agreement__E78Qc","Agreement__label":"Agreement_Agreement__label__BDMTU","Agreement__row":"Agreement_Agreement__row__b6tnA"};